<template>
  <div style="display: flex; align-items: center;">
    <!-- 时间维度选择 -->
    <el-select v-model="timeDimension" style="width: 120px; margin-right: 10px;" @change="handleDimensionChange">
      <el-option
        v-for="dimension in allowedDimensions"
        :key="dimension"
        :label="getDimensionLabel(dimension)"
        :value="dimension"
      />
    </el-select>

    <!-- 按日选择 -->
    <el-date-picker
      v-if="timeDimension === 'day'"
      :key="'day-picker'"
      v-model="dayRange"
      type="daterange"
      :picker-options="dayPickerOptions"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      format="yyyy-MM-dd"
      value-format="yyyy-MM-dd"
      @change="handleDayChange"
      :clearable="true"
    />

    <!-- 按月选择 -->
    <el-date-picker
      v-else-if="timeDimension === 'month'"
      :key="'month-picker'"
      v-model="selectedMonth"
      type="month"
      placeholder="请选择月份"
      format="yyyy-M"
      value-format="yyyy-M"
      @change="handleMonthChange"
      :clearable="true"
    />

    <!-- 按年选择 -->
    <el-date-picker
      v-else-if="timeDimension === 'year'"
      :key="'year-picker'"
      v-model="selectedYear"
      type="year"
      placeholder="请选择年份"
      format="yyyy"
      value-format="yyyy"
      @change="handleYearChange"
      :clearable="true"
    />
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  name: 'DateRangePicker',
  props: {
    allowedDimensions: {
      type: Array,
      default: () => ['day', 'month', 'year'],
    },
  },
  data() {
    return {
      timeDimension: 'month', // 默认选择月
      dayRange: [],
      selectedMonth: dayjs().subtract(1, 'month').format('YYYY-M'), // 默认选中上个月
      selectedYear: null,
      dayPickerOptions: {
        disabledDate: (time) => {
          const today = dayjs().startOf('day');
          return dayjs(time).isAfter(today, 'day') || dayjs(time).isSame(today, 'day');
        },
        onPick: ({ maxDate, minDate }) => {
          if (maxDate) {
            const diffDays = dayjs(maxDate).diff(dayjs(minDate), 'day');
            if (diffDays > 30) {
              this.$message.warning('最多只能选择30天');
              this.dayRange = [minDate];
            }
          }
        },
      },
    };
  },
  mounted() {
    // 在组件挂载时触发一次 update:search 事件，传递默认值
    this.handleMonthChange(this.selectedMonth);
  },
  methods: {
    getDimensionLabel(dimension) {
      const labels = {
        day: '日',
        month: '月',
        year: '年',
      };
      return labels[dimension] || dimension;
    },
    handleDayChange(dates) {
      if (dates && dates.length === 2) {
        const diffDays = dayjs(dates[1]).diff(dayjs(dates[0]), 'day');
        if (diffDays > 30) {
          this.$message.warning('最多只能选择30天');
          this.dayRange = [];
        }
      }
      this.$emit('update:search', { supplyDay: dates });
    },
    handleMonthChange(data) {
      let month = data ? data.split('-')[1] : null;
      let year = data ? data.split('-')[0] : null; 
      this.$emit('update:search', { supplyYear: year, supplyMonth: month });
    },
    handleYearChange(year) {
      this.$emit('update:search', { supplyYear: year });
    },
    handleDimensionChange(dimension) {
      // 清空原内容
      if (dimension === 'day') {
        this.dayRange = [];
      } else if (dimension === 'month') {
        this.selectedMonth = null;
      } else if (dimension === 'year') {
        this.selectedYear = null;
      }
      this.$emit('update:search', { dimension });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/dataBoard/components/DateRangePicker.vue